/**
 * @fileoverview Mock API Handlers - 前台訂單管理
 *
 * 命名規範: 前台 API 使用 camelCase 命名 (orderId, createTime, isPaid)
 *
 * Mock 的 API Endpoints:
 *
 * 1. POST /orders
 *    功能: 建立訂單
 *
 *    Request:
 *    ```json
 *    {
 *      "address": "台南市南區臺南市南區德興路",
 *      "country": "臺灣",
 *      "email": "qqq323618@gmail.com",
 *      "firstName": "姵綺",
 *      "full_name": "賴姵綺",
 *      "invoiceHead": "",
 *      "invoiceNum": "",
 *      "invoiceType": "個人",
 *      "is_check": 0,
 *      "lastName": "賴",
 *      "note": "",
 *      "notification": "電子郵件通知",
 *      "phone": "0926720019",
 *      "postalCode": "702",
 *      "product": [
 *        {
 *          "accessory": 1,
 *          "amount": 1,
 *          "engraving_content": {
 *            "type": "default",
 *            "content": {
 *              "gift": "",
 *              "godName": "",
 *              "respect": "",
 *              "templeName": ""
 *            }
 *          },
 *          "imageUrl": "https://s3.ap-northeast-1.amazonaws.com/kingdom9999.tw/7TJqMmRWTLbGBlw8UC8WvTuFqX9wmdzHnRSlvgHu5TnCRqhd6qGX6RObAz5GG93O",
 *          "length": "6.0",
 *          "shape": "如意",
 *          "style": "如意五福雙獅",
 *          "type": "peer",
 *          "unit": "cm",
 *          "way": "A",
 *          "weight": "0.10"
 *        }
 *      ],
 *      "sendWay": "郵局宅配",
 *      "user": "xcFnaOsu62l5DS6kDf0oiYlHdxEqrWkVr6dL7KMy1ijdBBvl1ecjqat81MS85v4Q"
 *    }
 *    ```
 *
 *    說明:
 *    - engraving_content.type 支援: "default", "sacredObject", "commemorative_license_plate",
 *      "commemorative_doorplate", "commemorative_medal"
 *    - 僅 type="default" 時，content 包含 templeName, godName, gift, respect
 *    - 其他 type 的 content 為空對象 {}
 *
 *    Response:
 *    ```json
 *    {
 *      "data": {
 *        "address": "台南市南區臺南市南區德興路",
 *        "country": "臺灣",
 *        "created_at": "2026-01-07 04:47:39",
 *        "email": "qqq323618@gmail.com",
 *        "full_name": "賴姵綺",
 *        "id": "4",
 *        "invoice_head": "",
 *        "invoice_num": "",
 *        "invoice_type": "個人",
 *        "is_check": 0,
 *        "is_notify": 0,
 *        "is_paid": 0,
 *        "is_shipped": 0,
 *        "note": "",
 *        "order_items": [
 *          {
 *            "accessory_name": 1,
 *            "accessory_price": 0,
 *            "amount": 1,
 *            "engraving_content": {
 *              "type": "default",
 *              "content": {
 *                "gift": "",
 *                "godName": "",
 *                "respect": "",
 *                "templeName": ""
 *              }
 *            },
 *            "gold_fee": 5000,
 *            "gold_price": 2500,
 *            "id": "31",
 *            "image_url": "https://s3.ap-northeast-1.amazonaws.com/kingdom9999.tw/7TJqMmRWTLbGBlw8UC8WvTuFqX9wmdzHnRSlvgHu5TnCRqhd6qGX6RObAz5GG93O",
 *            "length": "6.0",
 *            "shape": "如意",
 *            "style": "如意五福雙獅",
 *            "unit": "cm",
 *            "way": "A",
 *            "weight": "0.10"
 *          }
 *        ],
 *        "phone": "0926720019",
 *        "postal_code": "702",
 *        "postal_cost": 100,
 *        "postal_trace_code": null,
 *        "report": [],
 *        "send_way": "郵局宅配",
 *        "shipped_at": null,
 *        "sum": 5100,
 *        "trade_no": "TRD20260107004"
 *      }
 *    }
 *    ```
 *
 * 2. GET /orders
 *    功能: 獲取訂單列表
 *
 *    Response (直接返回陣列，不包裝 data):
 *    ```json
 *    [
 *      {
 *        "createTime": "2025-12-25 10:30:00",
 *        "id": "1",
 *        "isCreate": "1",
 *        "isPaid": "1",
 *        "isShipped": "0",
 *        "invoice_type": "個人",
 *        "orderId": "TRD20241220001",
 *        "paidTime": "2025-12-25 14:20:00",
 *        "product": [
 *          {
 *            "accessory_name": "紅色掛繩",
 *            "accessory_price": 100,
 *            "amount": 2,
 *            "imageUrl": "data:image/png;base64,...",
 *            "shape": "如意",
 *            "size": { "length": 5, "unit": "cm", "way": "A", "weight": "10" },
 *            "style": "經典福氣",
 *            "total": 10200
 *          }
 *        ],
 *        "shippedTime": "",
 *        "sum": "15500"
 *      }
 *    ]
 *    ```
 *
 * 3. GET /orders/:id
 *    功能: 獲取訂單詳情
 *
 *    Response (直接返回對象，不包裝 data):
 *    ```json
 *    {
 *      "createTime": "2025-12-25 10:30:00",
 *      "freight": "0",
 *      "id": "1",
 *      "isCreate": "1",
 *      "isPaid": "1",
 *      "isShipped": "0",
 *      "orderId": "TRD20241220001",
 *      "paidTime": "2025-12-25 14:20:00",
 *      "postalTraceCode": "",
 *      "product": [...],
 *      "productTotal": 15500,
 *      "receiverInfo": {
 *        "address": "台北市中正區重慶南路1號",
 *        "country": "台灣",
 *        "email": "wang@example.com",
 *        "full_name": "王小明",
 *        "invoiceHead": null,
 *        "invoiceNum": null,
 *        "invoiceType": "個人",
 *        "notification": "電子郵件通知",
 *        "phone": "0912345678",
 *        "postalCode": "10001",
 *        "sendWay": "郵局宅配"
 *      },
 *      "shippedTime": "",
 *      "sum": "15500"
 *    }
 *    ```
 */

import { rest } from "msw";
import { mockOrders, findOrderById, addMockOrder } from "../data/mockOrders";

// 從環境變數獲取 API URL
const API_BASE_URL = process.env.VUE_APP_API_URL;

// 輔助函數：將後台格式轉換為前台格式
function transformToFrontFormat(order) {
  return {
    invoice_type: order.invoice_type,
    id: order.id,
    orderId: order.trade_no,
    isCreate: "1",
    createTime: order.created_at,
    isPaid: String(order.is_paid),
    paidTime: order.is_paid === "1" ? order.created_at : "",
    isShipped: String(order.is_shipped),
    shippedTime: order.shipped_at || "",
    sum: order.sum,
    product: order.order_items.map((item) => ({
      shape: item.shape,
      style: item.style,
      imageUrl: item.image_url,
      size: {
        way: item.way,
        unit: item.unit,
        length: item.length,
        weight: item.weight,
      },
      amount: item.amount,
      total: (item.gold_fee + (item.accessory_price || 0)) * item.amount,
      accessory_name: item.accessory_name,
      accessory_price: item.accessory_price,
    })),
  };
}

// 輔助函數：將後台格式轉換為前台詳情格式
function transformToFrontDetailFormat(order) {
  const productTotal = order.order_items.reduce((sum, item) => {
    return sum + (item.gold_fee + (item.accessory_price || 0)) * item.amount;
  }, 0);

  return {
    id: order.id,
    orderId: order.trade_no,
    isCreate: "1",
    createTime: order.created_at,
    isPaid: String(order.is_paid),
    paidTime: order.is_paid === "1" ? order.created_at : "",
    isShipped: String(order.is_shipped),
    shippedTime: order.shipped_at || "",
    sum: order.sum,
    productTotal: productTotal,
    freight: order.freight,
    postalTraceCode: order.postal_trace_code || "",
    product: order.order_items.map((item) => ({
      shape: item.shape,
      style: item.style,
      imageUrl: item.image_url,
      size: {
        way: item.way,
        unit: item.unit,
        length: item.length,
        weight: item.weight,
      },
      amount: item.amount,
      total: (item.gold_fee + (item.accessory_price || 0)) * item.amount,
      accessory_name: item.accessory_name,
      accessory_price: item.accessory_price,
    })),
    receiverInfo: {
      notification: order.notification,
      sendWay: order.send_way,
      full_name: order.full_name,
      phone: order.phone,
      country: order.country,
      postalCode: order.postal_code,
      address: order.address,
      email: order.email,
      invoiceType: order.invoice_type,
      invoiceHead: order.invoice_head,
      invoiceNum: order.invoice_num,
    },
  };
}

// Handler 1: POST /orders - 建立訂單
const createOrderHandler = rest.post(
  `${API_BASE_URL}orders`,
  async (req, res, ctx) => {
    const orderData = await req.json();

    // 新增訂單到 mock 資料庫
    const newOrder = addMockOrder(orderData);

    // 返回格式：{ data: { id, trade_no, ... } }
    return res(
      ctx.status(200),
      ctx.json({
        data: {
          id: newOrder.id,
          trade_no: newOrder.trade_no,
          ...newOrder,
        },
      })
    );
  }
);

// Handler 2: GET /orders - 訂單列表
const getOrdersListHandler = rest.get(
  `${API_BASE_URL}orders`,
  (req, res, ctx) => {
    // 將所有訂單轉換為前台格式
    const frontOrders = mockOrders.map(transformToFrontFormat);

    // 直接返回陣列（不包裝 data）
    return res(ctx.status(200), ctx.json(frontOrders));
  }
);

// Handler 3: GET /orders/:id - 訂單詳情
const getOrderDetailHandler = rest.get(
  `${API_BASE_URL}orders/:id`,
  (req, res, ctx) => {
    const { id } = req.params;

    // 從 mock 資料庫查找訂單
    const order = findOrderById(id);

    if (!order) {
      return res(ctx.status(404), ctx.json({ message: "訂單不存在" }));
    }

    // 轉換為前台詳情格式並直接返回（不包裝 data）
    const frontOrderDetail = transformToFrontDetailFormat(order);

    return res(ctx.status(200), ctx.json(frontOrderDetail));
  }
);

// 匯出所有前台訂單 handlers
export const frontOrdersHandlers = [
  createOrderHandler,
  getOrdersListHandler,
  getOrderDetailHandler,
];
